import type { TrialInfo } from "@/views/Portfolio/types";

import { useFetch } from "./FetchHook";

/**
 * Fetches portfolio trial metadata (id, name, phase, asset, studyType, active, status)
 * from the `trials_metadata` endpoint for the current scope. Shared by every portfolio
 * screen to label its metric cards; TanStack Query dedupes the request across screens.
 * Returns `undefined` while loading, so callers should fall back to a default if needed.
 */
export function usePortfolioTrials(): TrialInfo[] | undefined {
  const { data } = useFetch({ endpointSuffix: "trials_metadata" });
  return data as TrialInfo[] | undefined;
}
